import React, { createContext, useEffect, useReducer } from "react";
import { useGoogleLogin } from "@react-oauth/google";
import axios from "../utils/axios";
import { setSession } from "../utils/jwt";
import { useNavigate } from "react-router-dom";
import { callUserActvity, fetchNotification, setNotifcationBedge } from "../redux/slices/CommonSlice";
import { checkDownloadStatus } from "../redux/slices/DisputeCenterSlice";
import $ from "jquery"

const INITIALIZE = "INITIALIZE";
const SIGN_IN = "SIGN_IN";
const SIGN_OUT = "SIGN_OUT";
const SIGN_UP = "SIGN_UP";
const ERROR_MESSAGE = "ERROR_MESSAGE";

const STAGES_ROUTES = {
  1:'/security-questions',
  2:'/report-audit',
  3:'/verify-info',
  4:'/upload-document',
  5:'/mailing-option',
  6:'/enhanced-dispute-onboarding'
}

const initialState = {
  isAuthenticated: false,
  isInitialized: false,
  user: null,
  errorMessage:""
};

const JWTReducer = (state, action) => {
  switch (action.type) {
    case INITIALIZE:
      return {
        isAuthenticated: action.payload.isAuthenticated,
        isInitialized: true,
        user: action.payload.user,
      };
    case SIGN_IN:
      return {
        ...state,
        isAuthenticated: true,
        user: action.payload.user,
      };
    case SIGN_OUT:
      return {
        ...state,
        isAuthenticated: false,
        user: null,
      };

    case SIGN_UP:
      return {
        ...state,
        isAuthenticated: true,
        user: action.payload.user,
      };
    case ERROR_MESSAGE:
      return {
        ...state,
        errorMessage:action.payload.error
      }

    default:
      return state;
  }
};

const AuthContext = createContext(null);

function AuthProvider({ children }) {
  const [state, dispatch] = useReducer(JWTReducer, initialState);
  const navigate = useNavigate()
  useEffect(() => {
    const initialize = async () => {
      try {
        const accessToken = window.localStorage.getItem("accessToken");

        // if (accessToken && isValidToken(accessToken)) {
        if (accessToken) {
          setSession(accessToken);

          // const response = await axios.get("/api/auth/my-account");
          // const { user } = response.data;

          dispatch({
            type: INITIALIZE,
            payload: {
              isAuthenticated: true,
            },
          });
        } else {
          dispatch({
            type: INITIALIZE,
            payload: {
              isAuthenticated: false,
              user: null,
            },
          });
        }
      } catch (err) {
        console.error(err);
        dispatch({
          type: INITIALIZE,
          payload: {
            isAuthenticated: false,
            user: null,
          },
        });
      }
    };

    initialize();
  }, []);

  const signIn = async (
    email,
    password,
    setStatus,
    setErrors,
    setSubmitting
  ) => {
    let formData = new FormData();
    formData.append("email", email);
    formData.append("password", password);
    formData.append("auth_type", "basic");
    const response = await axios.post("register/doLogin", formData);
    const data = response.data;
    if (data && data.error == 0) {
      setSession(data.token);
      let userName = data.user_name;
      localStorage.setItem("username", userName);
      if(data?.enable_2fa){
        return { enable_2fa: true }
      }
      dispatch({
        type: SIGN_IN,
        payload: {
          user: null,
        },
      });
      let formData = new FormData();
      formData.append("Token",data.token);
      await axios.post('form/checkDownloadStatus',formData);
      let formData1 = new FormData();
      formData1.append("Token",data.token);
      await axios.post('form/getClientNotifications',formData1);
      dispatch(setNotifcationBedge(true));

      let formData3 = new FormData();
      formData3.append("Token",data.token);
      formData3.append("event_log","User Login");
      await axios.post('form/makeActivityLog',formData3);

      let formData2 = new FormData();
      formData2.append("Token",data.token);
      let res = await axios.post('form/getWelcomeScreenCurrentStep',formData2);
      if(res && res.data.error === 0){
        let current_step = res.data.current_step;
        if(current_step === "completed"){
          navigate("/dashboard");
        }else{
          
          let routePath = STAGES_ROUTES[current_step];
          navigate(routePath);
        }
      }else{
        setStatus({ success: false });
        setErrors({ submit: res.msg });
        setSubmitting(false);  
      }

      
    } else {
      setStatus({ success: false });
      setErrors({ submit: data.msg });
      setSubmitting(false);
    }
  };




  const signInWithGoogle = useGoogleLogin({
    onSuccess: async (tokenResponse) => {
      try {
        const res = await axios.get(
          `https://www.googleapis.com/oauth2/v2/userinfo?access_token=${tokenResponse.access_token}`,
          {
            headers: {
              Authorization: `Bearer ${tokenResponse.access_token}`,
              Accept: "application/json",
            },
          }
        );
        let formData = new FormData();
        formData.append("email", res.data.email);
        // formData.append("gid", res.data.id);
        // formData.append("name", res.data.name);
        // formData.append("image", res.data.picture);
        formData.append("auth_type", "google");

        const response = await axios.post("register/doLogin", formData);
        const data = response.data;
        if (data && data.error == 0) {
          setSession(data.token);
          let userName = data.user_name;
          localStorage.setItem("username", userName);
          dispatch({
            type: SIGN_IN,
            payload: {
              user: null,
            },
          });
          let formData = new FormData();
          formData.append("Token",data.token);
          await axios.post('form/checkDownloadStatus',formData);
          let formData1 = new FormData();
          formData1.append("Token",data.token);
          await axios.post('form/getClientNotifications',formData1);
          dispatch(setNotifcationBedge(true));

          let formData3 = new FormData();
          formData3.append("Token",data.token);
          formData3.append("event_log","User Login with google");
          await axios.post('form/makeActivityLog',formData3);

          let formData2 = new FormData();
          formData2.append("Token",data.token);
          let res = await axios.post('form/getWelcomeScreenCurrentStep',formData2);
          if(res && res.data.error === 0){
            let current_step = res.data.current_step;
            if(current_step === "completed"){
              navigate("/dashboard");
            }else{
              let routePath = STAGES_ROUTES[current_step];
              navigate(routePath);
            }
          }
        }else{
          $.alert("User doesn't exist please sign up");
        }
      } catch (error) {
        $.alert(error.message);
      }
    },
    onError: (error) => {
      $.alert(error.message);
    },
    useOneTap: true,
  });

  const signOut = async () => {
    dispatch(callUserActvity("User Logout"));
    setSession(null);
    localStorage.removeItem("username");
    dispatch({ type: SIGN_OUT });
  };

  const signUp = async (
    email,
    password,
    firstname,
    lastname,
    phone,
    setStatus,
    setErrors,
    setSubmitting
  ) => {
    let formData = new FormData();
    formData.append("email", email);
    formData.append("password", password);
    formData.append("firstname", firstname);
    formData.append("lastname", lastname);
    formData.append("phone", phone);
    formData.append("auth_type", "basic");
    const response = await axios.post("register/register", formData);
    const data = response.data;
    // window.localStorage.setItem("accessToken", accessToken);
    if (data && data.error == 0) {
      setSession(data.token);
      localStorage.setItem("username", firstname + " " + lastname);
      // if(true){
      dispatch({
        type: SIGN_UP,
        payload: {
          user: data,
          // user:null
        },
      });
      let formData1 = new FormData();
      formData1.append("Token",data.token);
      await axios.post('form/getClientNotifications',formData1);
      dispatch(setNotifcationBedge(true));

      let formData3 = new FormData();
      formData3.append("Token",data.token);
      formData3.append("event_log","User Signup");
      await axios.post('form/makeActivityLog',formData3);
      // navigate("/choose-report");
      navigate('/security-questions');
    } else {
      setStatus({ success: false });
      setErrors({ submit: data.data });
      setSubmitting(false);
    }
  };

  const signUpWithGoogle = useGoogleLogin({
    onSuccess: async (tokenResponse) => {
      try {


        const userInfo = await axios.get(
          `https://www.googleapis.com/oauth2/v2/userinfo?access_token=${tokenResponse.access_token}`,
          {
            headers: {
              Authorization: `Bearer ${tokenResponse.access_token}`,
              Accept: "application/json",
            },
          }
        );

        const fields = 'birthdays,addresses,client_data,email_addresses,names,phone_numbers,occupations,locations,photos,coverPhotos';
        const person = await axios.get(
          `https://people.googleapis.com/v1/people/me?personFields=${fields}`,
          {
            headers: {
              Authorization: `Bearer ${tokenResponse.access_token}`,
              Accept: "application/json",
            },
          }
        );
        let formData = new FormData();
        formData.append("email", userInfo.data.email);
        // formData.append("gid", userInfo.data.id);
        formData.append("name", userInfo.data.name);
        formData.append("image", userInfo.data.picture);
        person.data?.birthdays && formData.append("dob",`${person.data?.birthdays[0].date.day}/${person.data?.birthdays[0].date.month}/${person.data.birthdays[0].date.year}`);
        formData.append("auth_type", "google");

        const response = await axios.post("register/register", formData);
        const data = response.data;
        if (data && data.error == 0) {
          setSession(data.token);
          localStorage.setItem("username", userInfo.data.name);
          // if(true){
          dispatch({
            type: SIGN_UP,
            payload: {
              user: data,
              // user:null
            },
          });
          let formData1 = new FormData();
          formData1.append("Token",data.token);
          await axios.post('form/getClientNotifications',formData1);
          dispatch(setNotifcationBedge(true));

          let formData3 = new FormData();
          formData3.append("Token",data.token);
          formData3.append("event_log","User Signup Google");
          await axios.post('form/makeActivityLog',formData3);
          navigate("/security-questions");
        }else{
          // $.alert(data.data);
          dispatch({
            type:ERROR_MESSAGE,
            payload: {
              error: data.data
            }
          })
        }
      } catch (error) {
        $.alert(error.message);
      }
    },
    onError: (error) => {
      $.alert(error.message);
    },
    useOneTap: true,
    scope: "openid https://www.googleapis.com/auth/user.addresses.read https://www.googleapis.com/auth/user.birthday.read https://www.googleapis.com/auth/user.phonenumbers.read"
  });


  const resetPassword = async (email) => {
    let formData = new FormData();
    formData.append("email", email);
    const response = await axios.post("register/forgotPasswordRequest", formData);
    const data = response.data;
    if (data && data.error == 0) {

      return data;
    } else {
      throw new Error(data.msg)
    }
  };

  const confirmResetPassword = async (id, password) => {
    let formData = new FormData();
    formData.append("id", id);
    formData.append("password", password);
    const response = await axios.post("register/resetByForgotPassword", formData);
    const data = response.data;
    if (data && data.error == 0) {
      return data;
    } else {
      throw new Error(data.msg)
    }
  };


  const dispatchTwoFactorAuth = async (code) => {

    let formData = new FormData();
    let accessToken = localStorage.getItem('accessToken');
    formData.append("Token", accessToken);
    formData.append("passcode", code);
    const response = await axios.post("register/verifyPasscode", formData);
    const data = response.data;
    

    if (data && data.error == 0 || data.success) {
      dispatch({
        type: SIGN_IN,
        payload: {
          user: null,
        },
      });
      navigate("/dashboard")
    } else {
      throw new Error(data.msg)
    }

  }

  const sendSignupVerificationCode = async ({phone, email, firstName, lastName, code}) => {
    let formData = new FormData();
    formData.append("email", email);
    formData.append("primary_phone", phone);
    formData.append("fname", firstName);
    formData.append("lname", lastName);
    formData.append("2fa_passcode", code);
    const response = await axios.post("register/twoFactorVerifyRegister", formData);
    const data = response.data;
    if (data && data.error == 0) {
      return data;
    } else {
      throw new Error(data.msg)
    }
  };

  return (
    <AuthContext.Provider
      value={{
        ...state,
        method: "jwt",
        signIn,
        signOut,
        signUp,
        resetPassword,
        signInWithGoogle,
        signUpWithGoogle,
        confirmResetPassword,
        dispatchTwoFactorAuth,
        sendSignupVerificationCode
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export { AuthContext, AuthProvider };
